export default {
    bind(el, binding) {
        el.setAttribute('routing-animation', true)

        if (binding.value.speedModifier === 0) {
            el.classList.add('is-preparedRoutingAnimation')
        }
    },
    inserted(el, binding) {
        if (binding.value.speedModifier === undefined || binding.value.speedModifier === null) {
            binding.value.speedModifier = 50
        }

        if (binding.value.index === undefined || binding.value.index === null) {
            binding.value.index = 1
        }

        if (binding.value.speedModifier > 0) {
            setTimeout(() => {
                el.classList.add('is-preparedRoutingAnimation')
            }, binding.value.speedModifier * binding.value.index)
        }
    }
}
